<template lang="pug">
div
  template(v-if="appointment && appointment.service")
    v-form(ref="form")
      v-card.mt-4.pa-4.round-lg(outlined)
        v-row(dense)
          v-col(cols="6")
            div.text-xs.neutral500--text {{ $t('service') }}
            div.text-sm.neutral700--text.mt-1 {{ appointment.service.product.name || '-' }}
          v-col(cols="6")
            div.text-xs.neutral500--text {{ $t('booking_fees') }}
            div.text-sm.neutral700--text.mt-1 {{ appointment.service.booking_fee > 0 ? this.$options.filters.displayPrice(appointment.service.booking_fee, $currency) : $t('no_fees_required') }}

      template(v-if="appointment.service.booking_fee > 0")
        div.text-md.font-semibold.neutral700--text.mt-8 {{ $t('this_service_requires_payment') }}
        div.mt-4.clickable(:style="payment.record === 'pay-now' ? activeBorder : inactiveBorder" @click="selectPaymentMethod('pay-now')")
          div.text-md.font-semibold.neutral700--text {{ $t('record_payment_now') }}

        v-expand-transition
          v-card.round-lg.neutral300.pa-4.mt-3(v-if="payment.record === 'pay-now'" flat)
            div.text-xs.font-semibold {{ $t('select_payment_method') }}
            v-select.text-sm.mt-2.round-xl(v-model="payment.payment_method" :items="paymentMethods" :placeholder="$t('select_payment_method')" background-color="neutral100" outlined :rules="rules.not_empty_select" :loading="isFetching" hide-details="auto")
            v-text-field.text-sm.mt-2.round-xl(v-model="payment.internal_description" :placeholder="$t('notes_on_payment_optional')" background-color="neutral100" outlined hide-details="auto")
        
        div.mt-4.clickable(:style="payment.record === 'pay-later' ? activeBorder : inactiveBorder" @click="selectPaymentMethod('pay-later')")
          div.text-md.font-semibold.neutral700--text {{ $t('record_payment_later') }}

      div.text-md.font-semibold.neutral700--text.mt-8(v-else) {{ $t('this_service_doesnt_requires_payment') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppointmentPayment',
  data () {
    return {
      paymentMethods: [],
      payment: {},
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
      activeBorder: {
        border: '2px solid var(--v-info500)',
        borderRadius: '8px',
        padding: '16px'
      },
      inactiveBorder: {
        border: '2px solid var(--v-neutral400)',
        borderRadius: '8px',
        padding: '16px'
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointment: 'clinic/getTempAppointment'
    }),
    paymentData () {
      return {
        payment: this.payment
      }
    }
  },
  watch: {
    paymentData: {
      deep: true,
      handler (val) {
        this.$store.commit('clinic/updateTempAppointment', val)
      } 
    }
  },
  mounted () {
    this.fetchPaymentMethods()
    if (this.appointment && this.appointment.service) {
      this.$set(this.payment, 'amount', this.appointment.service.booking_fee)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPaymentMethods () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/payment_methods`)
        .then(resp => {
          this.paymentMethods = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    selectPaymentMethod (method) {
      if (method === this.payment.record) {
        this.$set(this.payment, 'record', null)
      } else {
        this.$set(this.payment, 'record', method)
      }
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>